const React = require('react');
const { createElement: h, useState, useEffect } = React;
require('./UserGuidePage.css');

/* ── Section data ────────────────────────────────────────── */

var guideSections = [
  {
    id: 'videos',
    step: '01',
    navLabel: 'Demo-videoer',
    heading: 'Demo-videoer',
    intro: 'Se korte demoer af de centrale funktioner. Brug sektionerne nedenfor som reference mens du bygger.',
    videos: [
      { src: '/demos/quick-start.mp4', title: 'Hurtig start', description: 'Opret og kor et komplet workflow fra start til slut.' },
      { src: '/demos/variable-management.mp4', title: 'Variabler', description: 'Gem og del mellemresultater mellem knuder med typede workflow-variabler.' },
      { src: '/demos/condition.mp4', title: 'Betingelser', description: 'Forgren dit workflow baseret pa data med betingelsesknuder.' },
      { src: '/demos/loop.mp4', title: 'Loops', description: 'Iter over arrays og gentag delflows.' },
      { src: '/demos/intent-classify.mp4', title: 'AI-klassificering', description: 'Lad en LLM klassificere data og forgrene workflowet automatisk.' },
      { src: '/demos/planner.mp4', title: 'Build Agentic woirkflow with Planner', description: 'Brug planneren til at bygge agentic workflows automatisk.' },
      { src: '/demos/7.mp4', title: 'Node-gruppering', description: 'Organiser komplekse workflows ved at gruppere knuder.' },
      { src: '/demos/start-param.mp4', title: 'Start-parametre', description: 'Definer input-parametre som brugere udfylder ved korsel.' },
      { src: '/demos/6.mp4', title: 'Analyser og fix', description: 'Find fejl og lad AI foreslaa rettelser automatisk.' }
    ]
  },
  {
    id: 'getting-started',
    step: '02',
    navLabel: 'Kom i gang',
    heading: 'Kom i gang — dit forste workflow',
    intro: 'AlleFlow er en visuel workflow-builder. Du forbinder knuder (nodes) pa et uendeligt canvas for at bygge automatiserede flows. Folg trinene herunder for at oprette og kore dit forste workflow.',
    content: [
      { type: 'details', items: [
        { title: '1. Opret et nyt workflow', text: 'Abn dashboardet og klik "+ Nyt workflow". Giv det et sigende navn — du kan altid aendre det senere.' },
        { title: '2. Tiloj en Start-knude', text: 'Hvert workflow begynder med en Start-knude. Den er indgangspunktet og definerer eventuelle input-parametre som brugere skal udfylde ved korsel.' },
        { title: '3. Tiloj og forbind knuder', text: 'Traek knuder fra sidepanelet (System Objects) ud pa canvas. Forbind dem ved at traeke fra et udgaende anker (hojre side) til et indgaende anker (venstre side). Forbindelserne bestemmer udforelsesraekkefolgen.' },
        { title: '4. Konfigurer knuderne', text: 'Klik pa en knude for at abne dens indstillinger. Alt efter typen kan du skrive JavaScript-kode, definere betingelser, saette variabler eller konfigurere AI-klassificering.' },
        { title: '5. Kor workflowet', text: 'Tryk pa play-knappen i footeren. Resultater streames i realtid. Tryk stop for at afbryde. Har du Start-parametre, vises en formular forst.' }
      ]},
      { type: 'tips', items: [
        'Brug handvaerkojet til at panorere og markorvaerkojet til at vaelge flere knuder.',
        'Zoom med + / - knapperne i footeren. Klik pa procent-tallet for at nulstille til 100%.',
        'Slet flere markerede knuder med Delete eller Backspace.',
        'Du kan skifte mellem "Workflow"-editoren og "UI"-sidevisningen overst i footeren.'
      ]}
    ]
  },
  {
    id: 'node-types',
    step: '03',
    navLabel: 'Knude-typer',
    heading: 'Knude-typer — komplet oversigt',
    intro: 'AlleFlow har 12 knude-typer. Hver type loser et specifikt behov i dit workflow. Traek dem fra sidepanelet eller opret dem via AI-assistenten.',
    content: [
      { type: 'nodeCards', items: [
        { title: 'Start', desc: 'Indgangspunkt for workflowet. Definer hyperparametre (input-felter) som brugere udfylder ved korsel.' },
        { title: 'Condition', desc: 'Ja/nej-forgrening. Evaluerer regler mod data og sender flowet den ene eller anden vej. Har 4 ankerpunkter.' },
        { title: 'Variable', desc: 'Opret typede variabler (tekst, tal, dato, boolean, objekt, liste) der kan laeses og skrives af alle knuder.' },
        { title: 'Set Variable', desc: 'Opdater en eksisterende variabel under korsel. Understotter direkte vaerdi, input-source og increment/decrement (N++, N--).' },
        { title: 'Console.Log', desc: 'Print en besked til loggen for debugging. Nyttigt til at inspicere data mellem knuder under udvikling.' },
        { title: 'Computer Use', desc: 'Kor terminal-kommandoer og brug vaerkojer til at udfore opgaver automatisk.' },
        { title: 'Classify', desc: 'AI-klassificering via LLM. Definer labels og en instruktion — knuden returnerer den matchende kategori med confidence-score.' },
        { title: 'Router', desc: 'Multi-vejs forgrening (3+ udgange). Ligner Classify men med flere ruter. Nyttigt nar du har mere end ja/nej.' },
        { title: 'Loop', desc: 'Iter over en liste. Sender hvert element videre via "each"-grenen og signalerer "done" nar listen er gennemlobet.' },
        { title: 'Sleep', desc: 'Pauser workflowet i en bestemt varighed (millisekunder, sekunder eller minutter).' },
        { title: 'Flow (Ref)', desc: 'Kald et andet workflow som en knude. Oprettes ved at traeke et workflow fra playbook-exploreren ud pa canvas.' },
        { title: 'File Preview', desc: 'Vis en fil fra URL — understotter billeder, PDF og dokumenter.' }
      ]},
      { type: 'tips', items: [
        'Start simpelt med Start -> en knude -> Console.Log for at forsta flowet.',
        'Custom knuder (AI-genererede eller handskrevne) kan tilfojes fra "Custom Objects" i sidepanelet.',
        'Dupliker en knude for at genbruge dens konfiguration — duplikatet arver alle indstillinger.'
      ]}
    ]
  },
  {
    id: 'variables',
    step: '04',
    navLabel: 'Variabler',
    heading: 'Variabler — del data mellem knuder',
    intro: 'Variabler er typede vaerdier der lever i hele workflowet. De bruges til at dele data mellem knuder, gemme mellemresultater og styre flow-logik.',
    content: [
      { type: 'subheading', text: 'Understottede typer' },
      { type: 'bullets', items: [
        'Text (string) — Tekst-strenge, f.eks. navne, beskeder eller URL\'er.',
        'Num (int) — Heltal, f.eks. taellere, ID\'er eller belob.',
        'Date — Dato-vaerdier i ISO-format.',
        'Bool (boolean) — Sand/falsk vaerdier til flag og tilstande.',
        'Obj (json) — JSON-objekter til strukturerede data.',
        'List (array) — Lister af vaerdier, f.eks. til brug med Loop-knuden.'
      ]},
      { type: 'subheading', text: 'Laes og skriv variabler i kode' },
      { type: 'code', items: [
        { label: 'Laes en variabel i kode', code: 'var name = vars["customerName"];' },
        { label: 'Skriv en variabel i kode', code: 'setVar("orderTotal", 250);' },
        { label: 'Brug @-syntaks i parametre', code: '@customerName  ->  erstattes med variabelvaerdien' }
      ]},
      { type: 'tips', items: [
        'Brug sigende navne (f.eks. "orderTotal" i stedet for "x") sa workflowet er nemt at forsta.',
        'Marker en variabel som "static" (retain) hvis den skal huske sin vaerdi mellem korsler — nyttigt til taellere.',
        'Set Variable-knuden understotter increment (N++) og decrement (N--) for hurtig opdatering af taellere.'
      ]}
    ]
  },
  {
    id: 'conditions',
    step: '05',
    navLabel: 'Betingelser',
    heading: 'Betingelser — forgren dit workflow',
    intro: 'Betingelsesknuden evaluerer en regel og sender flowet ad den ene eller anden sti. Brug den til at bygge beslutningslogik baseret pa data.',
    content: [
      { type: 'subheading', text: 'Tilgaengelige operatorer' },
      { type: 'bullets', items: [
        'Sammenligning: equals (=), not equals (!=), greater than (>), greater or equal (>=), less than (<), less or equal (<=)',
        'Tekst: contains, starts with, ends with, regex',
        'Type-check: is blank, is not blank, is number, is string',
        'Boolean: is true, is false'
      ]},
      { type: 'subheading', text: 'Simpel vs. avanceret tilstand' },
      { type: 'details', items: [
        { title: 'Simpel tilstand', text: 'En betingelse pr. knude. Vaelg et felt, en operator og eventuelt en vaerdi. Flowet forgrener til ja- eller nej-anker.' },
        { title: 'Avanceret tilstand', text: 'Kombiner flere betingelser med AND/OR logik. Du kan gruppere op til 2 niveauer af betingelser for kompleks beslutningslogik.' }
      ]},
      { type: 'tips', items: [
        'Brug "is blank" og "is not blank" til at handtere valgfrie felter sikkert.',
        'Test altid begge grene (ja og nej) for at sikre workflowet opforer sig korrekt.',
        'Condition-knuden har 4 ankerpunkter (top, hojre, bund, venstre) — brug dem til paenere layout.'
      ]}
    ]
  },
  {
    id: 'ai-classify',
    step: '06',
    navLabel: 'AI-klassificering',
    heading: 'AI-klassificering og routing',
    intro: 'Lad en AI-model (LLM) analysere data og vaelge den rigtige kategori. Workflowet forgrener automatisk baseret pa resultatet.',
    content: [
      { type: 'subheading', text: 'Classify-knuden' },
      { type: 'details', items: [
        { title: 'Definer labels', text: 'Angiv kommaseparerede labels, f.eks. "positiv,negativ,neutral". Hver label far sin egen udgaende forbindelse. Max 20 labels.' },
        { title: 'Tiloj instruktion', text: 'Skriv en kort instruktion der hjaelper AI-modellen med at forsta konteksten, f.eks. "Klassificer kundens feedback som positiv, negativ eller neutral."' },
        { title: 'Output-format', text: 'Knuden returnerer { classification: "label", confidences: { label1: 0.9, label2: 0.1 } } — bade det valgte label og scores for alle labels.' }
      ]},
      { type: 'subheading', text: 'Router-knuden' },
      { type: 'bullets', items: [
        'Fungerer som Classify men til multi-vejs routing med 3+ udgange.',
        'Definer labels som kommaseparerede vaerdier (max 20).',
        'Hver label opretter en separat udgaende forbindelse.',
        'Brug bottom-ankeret som fallback nar ingen labels matcher.'
      ]},
      { type: 'tips', items: [
        'Hold labels korte og distinkte — "positiv" og "meget positiv" kan forvirre modellen.',
        'Tiloj en instruktion med eksempler for mere praecis klassificering.',
        'Brug confidence-scoren i downstream-betingelser til at handtere usikre resultater.'
      ]}
    ]
  },
  {
    id: 'start-params',
    step: '07',
    navLabel: 'Start-parametre',
    heading: 'Start-parametre — dit workflows input-kontrakt',
    intro: 'Start-knuden definerer hvilke input dit workflow kraever. Parametrene bliver til en formular som brugere udfylder for korsel, eller som sendes via API.',
    content: [
      { type: 'details', items: [
        { title: 'Tiloj parametre pa Start-knuden', text: 'Klik pa Start-knuden og tiloj hyperparametre. Hver parameter har et navn, en type og en valgfri beskrivelse.' },
        { title: 'Brugere udfylder formularen', text: 'Nar nogen korer workflowet, vises en formular med alle parametre. Brugeren udfylder felterne og trykker Kor.' },
        { title: 'Tilga input i downstream-knuder', text: 'Parametrene er tilgaengelige som inputs[0] i enhver knude der er forbundet efter Start. F.eks. inputs[0].customerName.' },
        { title: 'Via API', text: 'Ved API-kald sendes parametrene som JSON body i POST-requestet til /v1/workflows/:id/execute.' }
      ]},
      { type: 'tips', items: [
        'Tiloj altid en beskrivelse til hver parameter — det hjaelper andre brugere med at forsta hvad de skal indtaste.',
        'Brug parametre i stedet for hardcoded vaerdier, sa workflowet kan genbruges med forskellige input.',
        'Parametre virker ogsa i offentlige workflows (public share) hvor eksterne brugere udfylder formularen.'
      ]}
    ]
  },
  {
    id: 'organizing',
    step: '08',
    navLabel: 'Organisering',
    heading: 'Organisering og debugging',
    intro: 'Hold styr pa komplekse workflows med gruppering og brug den indbyggede analyse til at finde og rette fejl.',
    content: [
      { type: 'subheading', text: 'Node-gruppering' },
      { type: 'details', items: [
        { title: 'Opret en gruppe', text: 'Marker flere knuder med markorvaerkojet og grupper dem med et klik. Gruppen vises som en samlet enhed.' },
        { title: 'Fold sammen/ud', text: 'Fold en gruppe sammen for et rent overblik. Forbindelser til/fra gruppen bevares.' },
        { title: 'Flyt og kopier', text: 'Flyt hele gruppen som en enhed. Nyttigt til at reorganisere store workflows.' }
      ]},
      { type: 'subheading', text: 'Analyser og fix' },
      { type: 'bullets', items: [
        'Klik "Analyser" for at scanne workflowet for problemer: manglende forbindelser, ugyldige konfigurationer, tomme parametre.',
        'AI foreslar konkrete rettelser du kan anvende med et klik.',
        'Kor analyse regelmaessigt — isaer for du saetter et workflow i produktion.'
      ]},
      { type: 'tips', items: [
        'Grupper relaterede knuder tidligt — det er nemmere end at omstrukturere bagefter.',
        'Brug Console.Log-knuder til at inspicere data under debugging.',
        'Analyser-funktionen finder ogsa knuder der ikke er forbundet til flowet.'
      ]}
    ]
  },
  {
    id: 'scheduler-api',
    step: '09',
    navLabel: 'Planlaegning og API',
    heading: 'Planlaegning og API-integration',
    intro: 'Automatiser workflows med tidsplaner, eller integrer dem i dine egne systemer via REST API.',
    content: [
      { type: 'subheading', text: 'Planlaegning (Scheduler)' },
      { type: 'bullets', items: [
        'Tilgaengelige frekvenser: en gang, hvert minut, hver time, dagligt, ugentligt, manedligt.',
        'Opret en plan fra Scheduler-siden — vaelg workflow, frekvens og starttidspunkt.',
        'Aktiver eller pauser planer efter behov. Se seneste korselsstatus direkte i oversigten.'
      ]},
      { type: 'subheading', text: 'REST API' },
      { type: 'details', items: [
        { title: 'Autentificering', text: 'Brug en API-nogle i headeren: X-API-Key: din_nogle. Opret nogler fra API Keys-siden i dashboardet.' },
        { title: 'GET /v1/workflows', text: 'Hent en liste over alle dine workflows.' },
        { title: 'POST /v1/workflows', text: 'Opret et nyt workflow. Send { "workflowName": "Mit flow" } som JSON body.' },
        { title: 'GET /v1/workflows/:id', text: 'Hent detaljer for et specifikt workflow inkl. knuder, forbindelser og variabler.' },
        { title: 'POST /v1/workflows/:id/execute', text: 'Start en korsel. Send input-parametre som JSON body.' }
      ]},
      { type: 'tips', items: [
        'Start med manuelle korsler og brug planlaegeren nar workflowet er testet og stabilt.',
        'Opret separate API-nogler til hvert miljo (udvikling, staging, produktion).',
        'Brug offentlig deling (Public Share) til workflows der skal kores af eksterne brugere uden login.'
      ]}
    ]
  },
  {
    id: 'best-practices',
    step: '10',
    navLabel: 'Tips',
    heading: 'Tips og best practices',
    intro: 'Fa mest muligt ud af AlleFlow med disse praktiske rad baseret pa typiske workflows og monstre.',
    content: [
      { type: 'tips', items: [
        'Hold hvert workflow fokuseret pa en opgave. Brug Flow-ref knuden til at kaede workflows sammen i stedet for at bygge et kaempe flow.',
        'Navngiv knuder beskrivende (f.eks. "Hent kundedata" i stedet for "Node 3") — det gor workflowet selvdokumenterende.',
        'Brug variabler til at dele data i stedet for at kaede mange knuder direkte sammen.',
        'Test delflows isoleret med Console.Log-knuder for du forbinder dem til resten af workflowet.',
        'Kor "Analyser" regelmaessigt for at fange problemer tidligt — det er hurtigere end at debugge i produktion.',
        'Brug betingelsesknuder til at handtere edge-cases (tomme lister, manglende felter) i stedet for at lade workflowet fejle.',
        'Dokumenter komplekse workflows med gruppenavne og variabel-beskrivelser.',
        'Hav altid en Start-knude med parametre — selv simple workflows far gavn af konfigurerbare input.',
        'Gem folsomme data (API-nogler, passwords) som variabler — undga at hardcode dem i knude-kode.'
      ]}
    ]
  }
];

/* ── Video components ────────────────────────────────────── */

function VideoPlaceholder(props) {
  return h('div', { className: 'ug-video ug-video--placeholder' },
    h('div', { className: 'ug-video__placeholder-inner' },
      h('div', { className: 'ug-video__placeholder-icon' }, '\u25B6'),
      h('span', { className: 'ug-video__placeholder-label' }, 'Demo video kommer snart'),
      props.title ? h('span', { className: 'ug-video__placeholder-title' }, props.title) : null
    )
  );
}

function VideoEmbed(props) {
  var video = props && props.video;
  var autoPlay = props && props.autoPlay;
  var state = useState(false);
  var failed = state[0];
  var setFailed = state[1];

  if (!video) return null;

  if (video.youtubeId) {
    var ytSrc = 'https://www.youtube.com/embed/' + encodeURIComponent(video.youtubeId);
    if (autoPlay) ytSrc += '?autoplay=1';
    return h('div', { className: 'ug-video' },
      h('iframe', {
        src: ytSrc,
        title: video.title || 'Demo video',
        frameBorder: '0',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        allowFullScreen: true
      })
    );
  }

  if (video.src && !failed) {
    return h('div', { className: 'ug-video' },
      h('video', {
        src: video.src,
        controls: true,
        autoPlay: autoPlay || false,
        preload: 'metadata',
        poster: video.poster || undefined,
        'aria-label': video.title || 'Demo video',
        onError: function() { setFailed(true); }
      })
    );
  }

  return h(VideoPlaceholder, { title: video.title });
}

function VideoThumb(props) {
  var video = props.video;
  var onClick = props.onClick;
  return h('button', {
    type: 'button',
    className: 'ug__video-thumb-btn',
    onClick: onClick,
    'aria-label': 'Afspil ' + (video && video.title ? video.title : 'video')
  },
    video && video.poster
      ? h('img', { className: 'ug__video-thumb-img', src: video.poster, alt: '' })
      : (video && video.src
          ? h('video', {
              className: 'ug__video-thumb-img',
              src: video.src + '#t=0.1',
              preload: 'metadata',
              muted: true,
              playsInline: true,
              tabIndex: -1,
              'aria-hidden': 'true'
            })
          : h('div', { className: 'ug__video-thumb-fallback' })),
    h('span', { className: 'ug__video-thumb-play', 'aria-hidden': 'true' },
      h('svg', { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'currentColor' },
        h('path', { d: 'M8 5v14l11-7z' })
      )
    )
  );
}

function VideoModal(props) {
  var video = props.video;
  var onClose = props.onClose;

  useEffect(function() {
    if (typeof document === 'undefined') return;
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    var prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return function() {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, []);

  if (!video) return null;

  return h('div', {
    className: 'ug__modal',
    onClick: onClose,
    role: 'dialog',
    'aria-modal': 'true',
    'aria-label': video.title || 'Demo video'
  },
    h('div', {
      className: 'ug__modal-content',
      onClick: function(e) { e.stopPropagation(); }
    },
      h('button', {
        type: 'button',
        className: 'ug__modal-close',
        onClick: onClose,
        'aria-label': 'Luk'
      }, '\u00D7'),
      video.title ? h('h3', { className: 'ug__modal-title' }, video.title) : null,
      h(VideoEmbed, { video: video, autoPlay: true })
    )
  );
}

/* ── Scroll / active section ─────────────────────────────── */

function useActiveSection(ids) {
  var state = useState(ids[0] || '');
  var active = state[0];
  var setActive = state[1];

  useEffect(function() {
    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return;

    var visible = {};
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        visible[entry.target.id] = entry.isIntersecting ? entry.intersectionRatio : 0;
      });
      var best = '';
      var bestRatio = 0;
      ids.forEach(function(id) {
        var r = visible[id] || 0;
        if (r > bestRatio) { bestRatio = r; best = id; }
      });
      if (best) setActive(best);
    }, {
      rootMargin: '-20% 0px -60% 0px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    ids.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return function() { observer.disconnect(); };
  }, []);

  return active;
}

function scrollToSection(id) {
  var node = document.getElementById(id);
  if (node && typeof node.scrollIntoView === 'function') {
    node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/* ── Content block renderer ──────────────────────────────── */

function renderContentBlock(block, key) {
  if (!block) return null;

  switch (block.type) {
    case 'details':
      return h('div', { key: key, className: 'ug__details' },
        block.items.map(function(d, i) {
          return h('div', { key: i, className: 'ug__detail' },
            h('div', { className: 'ug__detail-title' }, d.title),
            h('div', { className: 'ug__detail-text' }, d.text)
          );
        })
      );

    case 'subheading':
      return h('h3', { key: key, className: 'ug__sub-heading' }, block.text);

    case 'bullets':
      return h('ul', { key: key, className: 'ug__bullets' },
        block.items.map(function(b, i) {
          return h('li', { key: i, className: 'ug__bullet' }, b);
        })
      );

    case 'nodeCards':
      return h('div', { key: key, className: 'ug__node-grid' },
        block.items.map(function(c, i) {
          return h('div', { key: i, className: 'ug__node-card' },
            h('div', { className: 'ug__node-card-title' }, c.title),
            h('div', { className: 'ug__node-card-desc' }, c.desc)
          );
        })
      );

    case 'code':
      return h('div', { key: key, className: 'ug__code-examples' },
        block.items.map(function(e, i) {
          return h('div', { key: i, className: 'ug__code-block' },
            e.label ? h('div', { className: 'ug__code-label' }, e.label) : null,
            h('pre', { className: 'ug__code-pre' },
              h('code', null, e.code)
            )
          );
        })
      );

    case 'tips':
      return h('div', { key: key, className: 'ug__tips' },
        h('div', { className: 'ug__tips-label' }, 'Tips'),
        block.items.map(function(t, i) {
          return h('div', { key: i, className: 'ug__tip' }, t);
        })
      );

    default:
      return null;
  }
}

/* ── Main page ───────────────────────────────────────────── */

function UserGuidePage(props) {
  var onBack = typeof props.onBack === 'function' ? props.onBack : null;
  var ids = guideSections.map(function(s) { return s.id; });
  var activeId = useActiveSection(ids);

  var mobileNavState = useState(false);
  var mobileNavOpen = mobileNavState[0];
  var setMobileNavOpen = mobileNavState[1];

  var modalState = useState(null);
  var activeVideo = modalState[0];
  var setActiveVideo = modalState[1];

  return h('div', { className: 'ug' },
    /* sidebar */
    h('aside', {
      className: 'ug__sidebar' + (mobileNavOpen ? ' ug__sidebar--open' : '')
    },
      h('div', { className: 'ug__sidebar-inner' },
        h('div', { className: 'ug__brand' },
          h('svg', {
            className: 'ug__brand-logo',
            width: 128, height: 30, viewBox: '0 0 128 30',
            fill: 'none', xmlns: 'http://www.w3.org/2000/svg',
            'aria-label': 'AlleFlow'
          },
            h('rect', { x: 0, y: 3, width: 24, height: 24, rx: 6, fill: '#1a1f2e' }),
            h('circle', { cx: 8, cy: 15, r: 2.5, fill: 'white', fillOpacity: 0.9 }),
            h('line', { x1: 10.5, y1: 15, x2: 13.5, y2: 15, stroke: 'white', strokeWidth: 1.5, strokeOpacity: 0.65 }),
            h('path', { d: 'M13 12 L17 15 L13 18', stroke: 'white', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' }),
            h('text', {
              x: 31, y: 21,
              fontFamily: 'Manrope, Segoe UI, sans-serif',
              fontSize: 17, fontWeight: 800,
              letterSpacing: -0.4, fill: '#1a1f2e'
            }, 'AlleFlow')
          ),
          h('span', { className: 'ug__brand-sub' }, 'Dokumentation')
        ),

        onBack ? h('button', {
          className: 'ug__back',
          onClick: onBack,
          type: 'button'
        }, '\u2190 Til forsiden') : null,

        h('nav', { className: 'ug__nav', 'aria-label': 'Guide-indhold' },
          h('span', { className: 'ug__nav-label' }, 'Indhold'),
          h('ul', { className: 'ug__nav-list' },
            guideSections.map(function(section) {
              var isActive = section.id === activeId;
              return h('li', { key: section.id, className: 'ug__nav-item' },
                h('a', {
                  href: '#' + section.id,
                  className: 'ug__nav-link' + (isActive ? ' ug__nav-link--active' : ''),
                  'aria-current': isActive ? 'true' : null,
                  onClick: function(event) {
                    event.preventDefault();
                    scrollToSection(section.id);
                    setMobileNavOpen(false);
                  }
                },
                  h('span', { className: 'ug__nav-step' }, section.step),
                  h('span', { className: 'ug__nav-text' }, section.navLabel)
                )
              );
            })
          )
        ),

        h('div', { className: 'ug__sidebar-footer' },
          h('span', { className: 'ug__sidebar-footer-label' }, 'Har du brug for mere hjaelp?'),
          h('span', { className: 'ug__sidebar-footer-text' }, 'Se API-dokumentation eller kontakt support.')
        )
      )
    ),

    /* mobile toggle */
    h('button', {
      type: 'button',
      className: 'ug__mobile-toggle',
      'aria-label': mobileNavOpen ? 'Luk menu' : 'Abn menu',
      'aria-expanded': mobileNavOpen ? 'true' : 'false',
      onClick: function() { setMobileNavOpen(!mobileNavOpen); }
    },
      h('span'), h('span'), h('span')
    ),

    mobileNavOpen
      ? h('div', {
          className: 'ug__scrim',
          onClick: function() { setMobileNavOpen(false); }
        })
      : null,

    /* main content */
    h('main', { className: 'ug__main' },
      h('header', { className: 'ug__hero' },
        h('span', { className: 'ug__eyebrow' }, 'Dokumentation'),
        h('h1', { className: 'ug__title' }, 'AlleFlow — komplet dokumentation'),
        h('p', { className: 'ug__intro' },
          'Alt du behoever for at bygge, kore og automatisere workflows. Fra grundlaeggende knude-typer til avanceret AI-klassificering, planlaegning og API-integration.'),
        h('div', { className: 'ug__notice', role: 'note' },
          h('span', { className: 'ug__notice-badge' }, 'Beta'),
          h('div', { className: 'ug__notice-body' },
            h('div', { className: 'ug__notice-title' }, 'Planner er i tidlig fase'),
            h('p', { className: 'ug__notice-text' },
              'Planneren kan generere forkerte forbindelser mellem knuder. Gennemga altid det genererede workflow og ret eventuelle connector-fejl for du korer det.')
          )
        )
      ),

      h('div', { className: 'ug__sections' },
        guideSections.map(function(section, idx) {
          return h('section', {
            key: section.id,
            id: section.id,
            className: 'ug__section'
          },
            h('div', { className: 'ug__section-head' },
              h('span', { className: 'ug__section-step' }, section.step),
              h('h2', { className: 'ug__section-heading' }, section.heading)
            ),

            section.intro
              ? h('p', { className: 'ug__section-intro' }, section.intro)
              : null,

            /* video list (section 01) */
            Array.isArray(section.videos) && section.videos.length
              ? h('ul', { className: 'ug__video-list' },
                  section.videos.map(function(v, i) {
                    return h('li', { key: i, className: 'ug__video-row' },
                      h('div', { className: 'ug__video-thumb' },
                        h(VideoThumb, {
                          video: v,
                          onClick: function() { setActiveVideo(v); }
                        })
                      ),
                      h('div', { className: 'ug__video-meta' },
                        h('h3', { className: 'ug__video-title' }, v.title),
                        v.description
                          ? h('p', { className: 'ug__video-desc' }, v.description)
                          : null
                      )
                    );
                  })
                )
              : null,

            /* content blocks */
            Array.isArray(section.content)
              ? section.content.map(function(block, bi) {
                  return renderContentBlock(block, 'b' + bi);
                })
              : null,

            idx < guideSections.length - 1
              ? h('div', { className: 'ug__section-divider', 'aria-hidden': 'true' })
              : null
          );
        })
      ),

      h('footer', { className: 'ug__footer' },
        h('div', { className: 'ug__footer-card' },
          h('h3', { className: 'ug__footer-title' }, 'Klar til at bygge dit forste workflow?'),
          h('p', { className: 'ug__footer-text' },
            'Log ind for at abne editoren, eller gennemga API-dokumentationen for integration.'),
          onBack ? h('button', {
            type: 'button',
            className: 'ug__footer-cta',
            onClick: onBack
          }, 'Kom i gang') : null
        )
      )
    ),

    activeVideo
      ? h(VideoModal, {
          video: activeVideo,
          onClose: function() { setActiveVideo(null); }
        })
      : null
  );
}

module.exports = UserGuidePage;
